import { fetchSubscribeInfo } from '@flowus/common/subscribe';
import type { SubscribeCategory, SubscribeInfo } from '@flowus/common/subscribe/type';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { LoadingContainer } from 'src/common/components/loading-container';
import { request } from 'src/common/request';
import { IframeLitePage } from 'src/components/page-preview/lite-page';
import { SubscribePage } from '../subscribe-page';
import { SubscribeCard } from './subscribe-card';
import { SubscribeCenterAside } from './subscribe-center-aside';
interface Props {
  keyword?: string;
}
export const SubscribeCenter: FC<Props> = () => {
  const [categories, setCategories] = useState<SubscribeCategory[]>();
  const [curSubscribeInfo, setSubscribeInfo] = useState<SubscribeInfo>();
  useEffect(() => {
    const fetch = async () => {
      const res = await fetchData();
      setCategories(res);
      const info = res?.[0]?.subscribeInfo?.[0];
      info && setSubscribeInfo(info);
    };
    void fetch();
  }, [setSubscribeInfo]);
  return (
    <div className="w-full h-[calc(100%-50px)] flex flex-col">
      {!categories && <LoadingContainer />}

      {/* <SubscribeHeader /> */}

      <div className="flex overflow-hidden h-full">
        {!__BUILD_IN__ && categories && curSubscribeInfo && (
          <SubscribeCenterAside
            categories={categories}
            currentPageId={curSubscribeInfo.id}
            onChangeSubscribeInfo={(info) => {
              setSubscribeInfo(info);
            }}
          />
        )}
        <div className="relative w-full h-full overflow-hidden">
          {/* 由于有个卡片显示，用iframe的话卡片的显示状态无法获取，需要多费功夫 */}
          {curSubscribeInfo?.id && (
            <div className="overflow-y-auto h-full w-full">
              {curSubscribeInfo.accessFee && curSubscribeInfo.accessFee > 0 ? (
                <IframeLitePage id={curSubscribeInfo.id} share />
              ) : (
                <SubscribePage key={curSubscribeInfo.id} uuid={curSubscribeInfo.id} />
              )}
            </div>
          )}
          {curSubscribeInfo?.id && <SubscribeCard subscribeInfo={curSubscribeInfo} />}
        </div>
      </div>
    </div>
  );
};

export const fetchData = async () => {
  const res = await fetchSubscribeInfo();
  if (!res) return;
  const docIds =
    res?.reduce((pre, cur) => {
      const ids = cur.subscribeInfo?.map((s) => s.payDocId || s.id);
      ids && pre.push(...ids);
      return pre;
    }, [] as string[]) ?? [];
  const accessFeeInfos = await request.infra.getPageInfos({
    docIds,
  });
  const map = new Map<string, number>();
  accessFeeInfos.forEach((v) => {
    map.set(v.blockId, v.accessFee);
  });
  res?.forEach((v) => {
    v.subscribeInfo?.forEach((s) => {
      s.accessFee = map.get(s.payDocId || s.id);
    });
  });
  return res;
};
